import React from 'react'
import 'bootstrap/dist/css/bootstrap.css'

const Title = () => {
    return (
        <div class="alert alert-dark my-5" role="alert">
            Listing all countries informations  
        </div>
    )
}

export default Title